import { length, path } from 'ramda';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { Icon } from '@ui/icons/Icon.tsx';

import HandlerContext from '../handlerContext.tsx';

const Wrapper = styled.div`
  background: var(--color-primary-05);
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--color-primaryText-15);
  margin-inline-start: -12px;
  margin-inline-end: -12px;
`;

const Title = styled.div`
  color: var(--color-primaryText);
  font-weight: 500;
  line-height: 18px;
  ${({ theme }) => theme.fontSize('14px')};
  text-transform: uppercase;

  align-self: center;
  margin-top: 8px;
  margin-bottom: 14px;
`;

const HorizontalContainer = styled.div`
  margin-inline-start: 11px;
  margin-inline-end: 11px;
  margin-bottom: 21px;

  display: flex;
  flex-direction: row;
  overflow-x: auto;
`;

const SecurityLane = styled.button`
  cursor: pointer;
  outline: none;

  background: var(--color-background);
  border: 1px solid var(--color-secondaryButton);
  box-sizing: border-box;
  border-radius: 8px;

  width: auto;
  height: 52px;
  padding: 12px 16px;

  margin: 0 6px;

  color: var(--color-primaryButton);
  ${({ theme }) => theme.fontSize('16px')};
  line-height: 24px;
  font-weight: 500;

  &:hover {
    background-color: var(--color-secondary-10);
  }

  &:active {
    background-color: var(--color-primaryText-10);
  }
`;

const IconWrapper = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OtherSecurityLanes = ({ poi, T }) => {
  const otherQueues = path(['queue', 'otherQueues'], poi);
  if (!length(otherQueues)) {
    return false;
  } else {
    return otherSecurityLanesView(otherQueues, 'Other lanes', T);
  }
};

const otherSecurityLanesView = (securityLanes, title, T) => {
  const { onSecurityLanePoiClick } = useContext(HandlerContext);
  return (
    <Wrapper>
      <Title>{T(`poiView:${title}`)}</Title>
      <HorizontalContainer>{securityLanes.map(getSecurityLaneView(onSecurityLanePoiClick))}</HorizontalContainer>
    </Wrapper>
  );
};

const getSecurityLaneView =
  onClick =>
  ({ poiId, displayText, imageId }) => {
    const content = imageId ? (
      <IconWrapper>
        <Icon name={imageId} cdn height={26} />
      </IconWrapper>
    ) : (
      displayText
    );

    return (
      <SecurityLane key={`security_lane_${poiId}`} onClick={() => onClick(poiId)}>
        {content}
      </SecurityLane>
    );
  };

export default OtherSecurityLanes;
